"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M14.7 5.3a1 1 0 00-1.4 0l-6 6a1 1 0 000 1.4l6 6a1 1 0 001.4-1.4L9.42 12l5.3-5.3a1 1 0 000-1.4z" } }] }, "name": "left", "theme": "outlined" };
exports.default = LeftOutlined;
